module.exports = __webpack_public_path__ + "img/industry-img4.856ebf35.png";